import React, { useState, useEffect, useCallback, useRef } from 'react';
import { FileCopyOutlined } from '@material-ui/icons';
import { Card } from '@material-ui/core';
import { connect } from 'react-redux';
/********** COMPONENTS **********/
import TitleWithIconBar from 'component/TitleWithIcon';
import LoadingSpinner from 'component/LoadingSpinner';
import AlertElement from 'component/AlertElement';
import Form from "component/Form/FormTwoColumns";
/********** SERVICES **********/
import ApiServices from 'service/ApiServices';
import { functions } from 'constant';
/********** REDUX **********/
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
/********** STYLES **********/
import { useStyles } from './style';

const ReportesRenuncias = (props) => {
/********** VARIABLES **********/
    const dataOPRedux = props.dataOP;
    const classes = useStyles();
    const controller = 'reportesGenerales';
    const [elementAlertModal, setElementAlertModal] = useState({openAlert: false, titleAlert: '', typeAlert: '' }),
    [loadingSpinner, setLoadingSpinner] = useState({openLoading: false, message: ''}),
    [elements] = useState({
        /* Inputs para Reporte Renuncias y Afiliaciones detallado */
        startDate: { 
            idelement: "startDate", value: null, label: "Fecha Inicial *", pattern: "^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", showInputControl: true,
            validators: 'required', errorMessages: ['Fecha requerida en formato: dd/MM/yyyy'], isError: false, elementType: 'date', disabled: false},
        finishDate: {
            idelement: "finishDate", value: null, label: "Fecha Final *", pattern: "^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", showInputControl: true,
            validators: 'required', errorMessages: ['Fecha requerida en formato: dd/MM/yyyy'], isError: false, elementType: 'date', disabled: false},
    }),
    [buttonList] = useState({
        "register": {"label": "Generar reporte", "callback": generateReport, "loading": false, "size": "medium", "color": "#fff", "icon": <FileCopyOutlined/>, "background": "", "showButton": true}
    });
/********** FUNCTIONS **********/
    /* Función para obtener reportes según los parametros seleccionados */
    async function generateReport(data){
        try {
            const valueOP = dataOPRedux;
            setLoadingSpinner({ ...loadingSpinner, openLoading: true, message: 'Generando reporte...' }); 
            const hasPermission = await ApiServices.userSecurity.hasPermission(controller, "afiliadosORenunciasDetallado");
            if (hasPermission.error) {
                setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'warning', titleAlert: 'Permisos Insuficientes', 
                    mensajeAlert: 'No cuenta con permisos para ejecutar esta acción, consulte con soporte.'});
                setLoadingSpinner({ ...loadingSpinner, openLoading: false});
            } else {
                let dataSend = {tipoDeReporte: 2, fechaFinal: functions.dateStringFormat(data.finishDate), 
                    fechaInicio: functions.dateStringFormat(data.startDate), idOp: valueOP.idOrganizacion};
                let titleReport = 'Reporte de renuncias detallado';
                let response = await ApiServices.reportesGenerales.getInformeDetalladoAfRenun(dataSend);
                if(response.error !== null){
                    var messageError = JSON.parse(response.error.message);
                    setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'error', titleAlert: messageError.message });
                } else {
                    functions.downloadPDFFromStringBase64(response.data, titleReport);
                }
                setLoadingSpinner({ ...loadingSpinner, openLoading: false});
            }
        } catch (exception) {
            setElementAlertModal({ ...elementAlertModal, openAlert: true, typeAlert: 'error', titleAlert: 'Error al generar el reporte', 
                mensajeAlert: exception + ', consulte con soporte.' });
            setLoadingSpinner({ ...loadingSpinner, openLoading: false});
        }
    }

    /*  El método cierra el "AlertElement" que muestra los modales de alertas, se ejecuta desde el "AlertElement" */
    const handCloseModal = () => {
        setElementAlertModal({...elementAlertModal, openAlert: false})
    }
    
/********** RENDER **********/
    return (
        <div className={classes.root}>
            {loadingSpinner.openLoading && <LoadingSpinner open={loadingSpinner.openLoading} message={loadingSpinner.message}/>}
            {elementAlertModal.openAlert && <AlertElement typeAlert={elementAlertModal.typeAlert} openModal={elementAlertModal.openAlert} 
                title={elementAlertModal.titleAlert} handCloseModal={handCloseModal} />}
            <TitleWithIconBar title="Reporte de Renuncias" icon={"/menu/Constancia.png"} />
            <div className={classes.cardMainContainer}>
                <Card className={classes.cardContainer}>
                    <div className={classes.searchContainer}>
                        <Form elements={elements} buttonList={buttonList} />
                    </div>
                </Card>
            </div>
        </div>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportesRenuncias);